import { queryGraphQL } from 'common/util/query';
import { aliasNodeWithArgs, toQuery} from 'common/util/queryHelper';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';

export const ACTIONS = {
    FORMS_LOAD_FORM_KEY: 'FORMS_LOAD_FORM_KEY'
};

export function loadForm(source, key) {

    return dispatch => {
        const query = aliasNodeWithArgs('form', 'getForm', {
            source,
            key
        }, [
            'key',
            'name'
        ]);

        return queryGraphQL(toQuery(query)).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', response.errors.map(e => e.message)));
            } else {
                dispatch(writeForm(response.data.form));
            }
        });
    };
}

export function unloadFormKey() {
    return writeForm(undefined);
}

function writeForm(form) {
    return {
        type: ACTIONS.FORMS_LOAD_FORM_KEY,
        payload: form
    };
}
